export var MuiTextFieldProps = {
    variant: 'outlined',
};
export var getMuiTextFieldOverrides = function (_a) {
    var spacing = _a.spacing, palette = _a.palette;
    return ({});
};
//# sourceMappingURL=MuiTextField.js.map